<template>
  <svg viewBox="0 0 1080 336" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="1080" height="336">
  <g style="mix-blend-mode:hard-light" opacity="0.5">
  <rect width="1080" height="336" fill="#181F36"/>
  </g>
  </mask>
  <g mask="url(#mask0)">
  <g style="mix-blend-mode:hard-light" opacity="0.5">
  <circle cx="116.5" cy="251.5" r="188.5" fill="url(#paint0_radial)"/>
  </g>
  <g style="mix-blend-mode:hard-light" opacity="0.5">
  <ellipse cx="758" cy="31.5" rx="189" ry="188.5" fill="url(#paint1_radial)"/>
  </g>
  <g style="mix-blend-mode:hard-light" opacity="0.5">
  <circle cx="961.5" cy="263.5" r="188.5" fill="url(#paint2_radial)"/>
  </g>
  <g style="mix-blend-mode:hard-light" opacity="0.5">
  <circle cx="12.5" cy="23.5" r="188.5" fill="url(#paint3_radial)"/>
  </g>
  </g>
  <defs>
  <radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(116.5 251.5) rotate(90) scale(188.5)">
  <stop stop-color="#56A8D1"/>
  <stop offset="1" stop-color="#56A8D1" stop-opacity="0"/>
  </radialGradient>
  <radialGradient id="paint1_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(758 31.5) rotate(90) scale(188.5 189)">
  <stop stop-color="#6756D1"/>
  <stop offset="1" stop-color="#6D5BD9" stop-opacity="0"/>
  </radialGradient>
  <radialGradient id="paint2_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(961.5 263.5) rotate(90) scale(188.5)">
  <stop stop-color="#8CD156"/>
  <stop offset="1" stop-color="#92D95B" stop-opacity="0"/>
  </radialGradient>
  <radialGradient id="paint3_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(12.5 23.5) rotate(90) scale(188.5)">
  <stop stop-color="#56A8D1"/>
  <stop offset="1" stop-color="#56A8D1" stop-opacity="0"/>
  </radialGradient>
  </defs>
  </svg>
</template>

<script>
  export default {
    //
  }
</script>
